import {useAppSelector} from '../../../store/store';
import formStyles from './../../../components/form/form.module.scss';
import {CustomerPreferences, getPreference, hasDisabledPreference} from '../../../support/get_data.ts';
import {__, transString} from '../../../support/lang/translations';
import {Switch} from './../../../components/switch/switch.tsx';
import {Card} from '../../../components/card/card.tsx';
import {Icon} from '../../../components/icon/icon.tsx';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending.ts';

export function Preferences() {
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);

    return (
        <>
            {hasDisabledPreference(meData) ? (
                <Card gray={true}>
                    <FlexRow alignment={Alignment.Start}>
                        <FlexColumn>
                            <Icon iconClassName="fa-light fa-circle-info" outline={true} />
                        </FlexColumn>
                        <FlexColumn>
                            <strong style={{margin: '0 auto 0 1rem'}}>
                                {__('profile.preferences.notifications.disabled.title')}
                            </strong>
                            <span style={{margin: '0 auto 0 1rem'}}>
                                {__('profile.preferences.notifications.disabled.message')}
                            </span>
                        </FlexColumn>
                    </FlexRow>
                </Card>
            ) : null}
            <div className={formStyles.form}>
                <div className={formStyles.form__columns}>
                    <div className={formStyles.column}>
                        <h3>{__('profile.preferences.titles.categories')}</h3>

                        <Switch
                            disabled={isLoading}
                            defaultChecked={
                                getPreference(meData, CustomerPreferences.RECEIVE_GENERAL_MESSAGES) ?? false
                            }
                            name={CustomerPreferences.RECEIVE_GENERAL_MESSAGES}
                            label={transString('profile.preferences.receive_general_messages')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={
                                getPreference(meData, CustomerPreferences.RECEIVE_SERVICE_MESSAGES) ?? false
                            }
                            name={CustomerPreferences.RECEIVE_SERVICE_MESSAGES}
                            label={transString('profile.preferences.receive_service_messages')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={
                                getPreference(meData, CustomerPreferences.RECEIVE_MARKETING_MESSAGES) ?? false
                            }
                            name={CustomerPreferences.RECEIVE_MARKETING_MESSAGES}
                            label={transString('profile.preferences.receive_marketing_messages')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={
                                getPreference(meData, CustomerPreferences.RECEIVE_PERSONAL_MESSAGES) ?? false
                            }
                            name={CustomerPreferences.RECEIVE_PERSONAL_MESSAGES}
                            label={transString('profile.preferences.receive_personal_messages')}
                        />
                    </div>

                    <div className={formStyles.column}>
                        <h3>{__('profile.preferences.titles.channels')}</h3>

                        <Switch
                            disabled={isLoading}
                            defaultChecked={getPreference(meData, CustomerPreferences.RECEIVE_MAIL_CHANNEL) ?? false}
                            name={CustomerPreferences.RECEIVE_MAIL_CHANNEL}
                            label={transString('profile.preferences.receive_mail_channel')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={getPreference(meData, CustomerPreferences.RECEIVE_PHONE_CHANNEL) ?? false}
                            name={CustomerPreferences.RECEIVE_PHONE_CHANNEL}
                            label={transString('profile.preferences.receive_phone_channel')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={
                                getPreference(meData, CustomerPreferences.RECEIVE_MOBILE_PHONE_CHANNEL) ?? false
                            }
                            name={CustomerPreferences.RECEIVE_MOBILE_PHONE_CHANNEL}
                            label={transString('profile.preferences.receive_mobile_phone_channel')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={getPreference(meData, CustomerPreferences.RECEIVE_SMS_CHANNEL) ?? false}
                            name={CustomerPreferences.RECEIVE_SMS_CHANNEL}
                            label={transString('profile.preferences.receive_sms_channel')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={
                                getPreference(meData, CustomerPreferences.RECEIVE_WHATSAPP_CHANNEL) ?? false
                            }
                            name={CustomerPreferences.RECEIVE_WHATSAPP_CHANNEL}
                            label={transString('profile.preferences.receive_whatshapp_channel')}
                        />

                        <Switch
                            disabled={isLoading}
                            defaultChecked={getPreference(meData, CustomerPreferences.RECEIVE_EMAIL_CHANNEL) ?? false}
                            name={CustomerPreferences.RECEIVE_EMAIL_CHANNEL}
                            label={transString('profile.preferences.receive_email_channel')}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
